var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.matches.length > 0)?_c('span',{staticClass:"match-counter"},[_vm._v(_vm._s(_vm.matches.length))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }